import React, {ReactNode} from 'react';
import './SidebarScrollableContent.scss';

export interface SidebarScrollableContentProps {
  readonly children: ReactNode;
}

function SidebarScrollableContent({ children }: SidebarScrollableContentProps) {
  const [scrolled, setScrolled] = React.useState(false);

  function onScroll(e: React.UIEvent<HTMLDivElement, UIEvent>) {
    setScrolled(e.currentTarget.scrollTop > 0);
  }

  const cssClassNames = ['sidebar-scrollable-content'];
  if (scrolled) {
    cssClassNames.push('sidebar-scrollable-content__scrolled');
  }

  return <div className={cssClassNames.join(' ')}
              onScroll={(e) => onScroll(e)}>
    {children}
  </div>;
}

export default SidebarScrollableContent;
